
const getConfig = () => {
    const project = process.env.VUE_APP_PROJECT;
    const appId = process.env.VUE_APP_APPID;
    const secret = process.env.VUE_APP_SECRET;
    const apiUrl = process.env.VUE_APP_APIURI+'admin/';
    const version = process.env.VUE_APP_VERSION;
    const isweixin = process.env.VUE_APP_ISWEIXIN;
    const coreapi= process.env.VUE_APP_COREAPI;
    return { project, appId, secret, apiUrl, version, isweixin,coreapi };
};
  export default getConfig;